import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild } from "@angular/core";
import { SettingsName } from "@app/class/SettingsName";
import { ICombinedPreferences } from "@app/interfaces/ICombinedPreferences";
import { IAutoCompleteResult, MapzenService } from "@app/services/mapzen.service";
import { SessionService } from "@app/services/session.service";
import { TranslationService } from "@services/translation.service";
import { VAutocompleteComponent } from "../v-autocomplete.component";
import { Place } from "./place";
import "./v-places-autocomplete.component.scss";

@Component({
    selector: "v-places-autocomplete",
    template: require('./v-places-autocomplete.component.html')
})
export class VPlacesAutocompleteComponent implements OnInit, AfterViewInit {
    @ViewChild('autocomplete') autocomplete: VAutocompleteComponent<any>;

    @Input() label: string = this.translationService.t("Common.Place");
    @Input() placeholder: string = this.translationService.t("PlacesAutoComplete.SelectPlace");

    @Output() placeSelected = new EventEmitter<Place>();

    itemFilter = () => true;

    countryCode: string;
    itemPromise: Promise<IAutoCompleteResult[]> = Promise.resolve([]);

    constructor(
        private readonly sessionService: SessionService,
        private readonly translationService: TranslationService,
        private readonly mapzenService: MapzenService
    ) { }

    ngOnInit(): void {
        this.setupCountryCode();
    }

    ngAfterViewInit(): void {
        setTimeout(() => {
            // It is not nice solution, but this "trick" allows us
            // not to modify v-autocomplete so we don't risk making
            // regression, as this functionality here seems to be
            // one time only
            this.autocomplete.showDropdown = false;
        });
    }

    onTextChanged(text: string): void {
        this.itemPromise = this.getItems(text);
    }

    onItemClicked(item: IAutoCompleteResult): void {
        const place: Place = {
            name: item.formatted,
            lat: item.geometry.lat,
            lng: item.geometry.lng
        }

        this.placeSelected.next(place);
    }

    private setupCountryCode(): void {
        const userOptions = this.sessionService.getItem<ICombinedPreferences>(SettingsName.UserOptions);
        this.countryCode = userOptions.CountryCode.Value;
    }

    private async getItems(text: string): Promise<IAutoCompleteResult[]> {
        const countryCode = this.countryCode || "GB";
        const result = await this.mapzenService.autocomplete(text, countryCode);

        return result.results;
    }
}
